import merge from 'lodash.merge';
import queryString from 'query-string';
export const updateQueryUrl = (history, newParams) => {
    let queryParams = queryString.parse(history.location.search, { parseNumbers: true });
    queryParams = merge(queryParams, newParams);
    const queryParamsClone = {};
    for (const key in queryParams) {
        if (queryParams[key] === '' || queryParams[key] === '-1')
            continue;
        queryParamsClone[key] = queryParams[key];
    }
    history.push(`${history.location.pathname}?${queryString.stringify(queryParamsClone)}`);
};
//# sourceMappingURL=updateQueryUrl.js.map